export default "__VITE_ASSET__Bqt1waAz__"